<template>
    <Modal name="add-symbol" title="Фраза" @closed="onClose">
        <template #content>
            <form class="form" @submit.prevent="save()">
                <Spinner v-if="loading" />
                <div class="form-group">
                    <label class="form-group__label">Символ</label>
                    <FormInput
                        v-model="localSymbol.symbol"
                        type="text"
                        placeholder="Введите фразу"
                        name="symbol"
                        required
                        style="margin-top: 10px"
                    />
                </div>
                <div class="form-group">
                    <label class="form-group__label">Замена</label>
                    <textarea
                        ref="replace"
                        v-model="localSymbol.replace"
                        class="form-group__textarea"
                        placeholder="Введите замену"
                        rows="2"
                        required
                        style="display: block; margin-top: 10px"
                    ></textarea>
                </div>
                <template v-if="!symbol">
                    <div class="form-group">
                        <label class="form-group__label">Язык</label>
                        <MultiSelect
                            v-model="localSymbol.lang"
                            :options="languages"
                            :form-value-text="
                                (item) => item.label.original || item.label[$i18n.locale]
                            "
                            with-filter
                            emit-prop="id"
                            empty-text="No languages"
                            style="width: 360px"
                            required
                        >
                            <template #default="{ item }">
                                {{ item.label.original || item.label[$i18n.locale] }}
                            </template>
                        </MultiSelect>
                    </div>
                    <div class="form-group">
                        <label class="form-group__label">Провайдер</label>
                        <CustomSelect
                            v-model="localSymbol.provider"
                            :options="providers"
                            :form-value-text="(item) => item.name"
                            emit-prop="id"
                            style="max-width: 360px; margin-top: 10px"
                            required
                        >
                            <template #default="{ item }">
                                {{ item.name }}
                            </template>
                        </CustomSelect>
                    </div>
                </template>
                <div class="form-group">
                    <Switcher v-model="localSymbol.is_active">Активна</Switcher>
                </div>
                <div style="display: flex; align-items: center">
                    <button :disabled="loading" class="button button--medium" @click="keep = false">
                        Сохранить
                    </button>
                    <button
                        :disabled="loading"
                        class="button button--medium button--outlined"
                        style="margin-left: 15px"
                        @click="keep = true"
                    >
                        Сохранить и добавить ещё
                    </button>
                </div>
                <ErrorList :error="error" />
            </form>
        </template>
    </Modal>
</template>

<script>
import { ApiClient } from '@/plugins/axios';
import { Modal } from '@speechki-frontend/shared/ui/modals';
import {
    FormInput,
    CustomSelect,
    ErrorList,
    MultiSelect,
} from '@speechki-frontend/shared/ui/forms';
import Switcher from '@speechki-frontend/shared/ui/Switcher/Switcher';

export default {
    name: 'DictionaryPhraseModal',
    components: {
        Modal,
        FormInput,
        CustomSelect,
        Switcher,
        ErrorList,
        MultiSelect,
    },
    props: {
        symbol: {
            type: Object,
            default: null,
        },
        speakers: {
            type: Array,
            default: () => [],
        },
        languages: {
            type: Array,
            default: () => [],
        },
        providers: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            localSymbol: {
                symbol: '',
                replace: '',
                is_active: true,
                provider: undefined,
                lang: [],
            },
            loading: false,
            error: undefined,
            shouldReload: false,
            keep: false,
        };
    },
    created() {
        if (this.symbol) {
            this.localSymbol = { ...this.symbol };
            this.localSymbol.lang = Array.isArray(this.symbol.language)
                ? this.symbol.language.map((lang) => lang.id)
                : [this.symbol.language.id];
            this.localSymbol.provider = this.symbol.provider.id;
        }
    },
    methods: {
        async save() {
            try {
                this.error = undefined;
                this.loading = true;
                let method = this.symbol ? 'patch' : 'post';
                let URL = this.symbol
                    ? `/api/v1/admin/phrase_dictionary/special_symbols/${this.symbol.id}/`
                    : '/api/v1/admin/phrase_dictionary/special_symbols/';

                let { symbol, replace, is_active, provider, lang } = this.localSymbol;

                let data = {
                    symbol,
                    replace,
                    is_active,
                    provider: provider,
                    languages: lang,
                };

                await ApiClient[method](URL, data);

                this.shouldReload = true;

                this.localSymbol = {
                    symbol: '',
                    replace: '',
                    is_active: true,
                };

                this.loading = false;

                if (this.keep) {
                    return;
                }

                this.$emit('closed', true);
            } catch (e) {
                console.log(e);
                this.error = e;
                this.loading = false;
            }
        },
        onClose() {
            this.$emit('closed', this.shouldReload);
        },
    },
};
</script>
